import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { inject } from 'helpers/mobx'
import { getCanonicalFromHreflangs } from 'helpers/seo'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import React, { FC } from 'react'
import { getStaticPageSeo } from './logic'

interface IProps {
  title: string
  renderHreflangs: boolean
  links: string[]
  canonicalUrl: string
}

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default inject(
  store => {
    const { originByLocaleMap, translatedUrlsPerLocale } = store.urlManagerStore
    const { locale } = store.localeStore
    const hasDroppedSubDomain = store.tadaridaFeatureStore.hasDroppedSubDomain

    const pageSeo = getStaticPageSeo(
      store.staticPageStore.currentStaticPage,
      store.t,
      originByLocaleMap,
      translatedUrlsPerLocale,
      store.featureStore.getDisabledExpansionLocales(),
    )
    const canonicalUrl = getCanonicalFromHreflangs({
      hreflangs: pageSeo.links,
      locale,
    })

    const description =
      store.staticPageStore.currentStaticPage === 'voucher_conditions'
        ? store.t(
            'Hier erfährst Du, wie Du Gutscheine im ABOUT YOU Online Shop einlösen kannst und was hierbei die allgemeinen Gutscheinbedingungen sind. Jetzt informieren.',
          )
        : undefined

    const robots =
      store.staticPageStore.currentStaticPage === 'campaign_conditions'
        ? 'noindex, follow'
        : 'index, follow'

    return {
      title: pageSeo.title,
      renderHreflangs: true,
      links: pageSeo.links,
      description,
      canonicalUrl,
      customTitleTemplate: pageSeo.customTitleTemplate,
      robots,
      hasDroppedSubDomain,
    }
  },
  { observe: true },
)((props: IProps) => <DocumentHead {...props} />)
